/**
 * PasswordInput Atom — Input preset for password fields.
 *
 * A thin, discoverable wrapper over {@link Input} that fixes `type="password"`.
 * The accessible reveal ("eye") toggle is inherited from Input and rendered by
 * default; opt out with `revealToggle={false}`. This is the canonical component
 * every login / password-change field across the fleet should use.
 *
 * @layer atom
 * @package @plerity/ui-core
 */

import { forwardRef } from "react";
import { Input } from "../Input/Input";
import type { PasswordInputProps } from "./PasswordInput.types";

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ autoComplete = "current-password", ...props }, ref) => (
    <Input ref={ref} type="password" autoComplete={autoComplete} {...props} />
  )
);

PasswordInput.displayName = "PasswordInput";
